import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Button, OverlayTheme, OverlayType } from "..";

var CheckoutAsGuest = function CheckoutAsGuest(_ref) {
  var overlay = _ref.overlay,
      checkoutUrl = _ref.checkoutUrl;
  var intl = useIntl();
  return React.createElement("div", {
    className: "checkout-login__guest"
  }, React.createElement("h3", {
    className: "checkout__header"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Continue as a guest",
    "id": "components.CheckoutLogin.CheckoutAsGuest.1006283488"
  }, "id", "components.CheckoutLogin.CheckoutAsGuest.1006283488"))), React.createElement("p", null, intl.formatMessage(_defineProperty({
    defaultMessage: "If you don’t wish to register an account, don’t worry. You can checkout as a guest. We care about you just as much as any registered user.",
    "id": "components.CheckoutLogin.CheckoutAsGuest.647198093"
  }, "id", "components.CheckoutLogin.CheckoutAsGuest.647198093"))), React.createElement(Link, {
    to: checkoutUrl
  }, React.createElement(Button, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Continue as a guest",
    "id": "components.CheckoutLogin.CheckoutAsGuest.1006283488"
  }, "id", "components.CheckoutLogin.CheckoutAsGuest.1006283488")))), React.createElement("p", null, intl.formatMessage(_defineProperty({
    defaultMessage: "or you can",
    "id": "components.CheckoutLogin.CheckoutAsGuest.3896074202"
  }, "id", "components.CheckoutLogin.CheckoutAsGuest.3896074202")), React.createElement("span", {
    className: "u-link",
    onClick: function onClick() {
      return overlay.show(OverlayType.register, OverlayTheme.right);
    },
    role: "button",
    tabIndex: 0
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "create an account",
    "id": "components.CheckoutLogin.CheckoutAsGuest.2132450234"
  }, "id", "components.CheckoutLogin.CheckoutAsGuest.2132450234")))));
};

export default CheckoutAsGuest;